var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSpinner)?_c('div',{staticClass:"text-center p-5"},[_c('div',{staticClass:"spinner-border text-success",style:({
      height: _vm.height,
      width: _vm.width,
    }),attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }